import createSelector from 'selectorator'
import { identity } from 'ramda'
import { RootState } from 'src/state/types'
import { NAMESPACE } from './constants'
import { TTpnSend, TTpnSettings, TTpnState } from './types'

export const getSlice = <K extends keyof TTpnState>(key: K) =>
  createSelector<RootState, TTpnState[K]>([`api.${NAMESPACE}.${key}`], identity)

export const getTpnSettings = getSlice('settings')

export const isTpnSettingsLoaded = getSlice('loaded')

export const didTpnSettingsLoadFail = getSlice('loadFailed')

export const getTpnLastSendResult = getSlice('lastSendResult')

export const getTpnSaveError = getSlice('saveError')

export const isTpnConnected = createSelector<RootState, boolean>([getTpnSettings], (settings: TTpnSettings | null) =>
  Boolean(settings),
)

export const isTpnAutoSendEnabled = createSelector<RootState, boolean>(
  [getTpnSettings],
  (settings: TTpnSettings | null) => settings?.autoSend ?? false,
)

export const getTpnLastSend = createSelector<RootState, TTpnSend | null>(
  [getTpnSettings],
  (settings: TTpnSettings | null) => settings?.lastSend ?? null,
)
